import Model from "./modal";
import Image from "next/image";
import { useTranslation } from "react-i18next";
import Done from "assets/svg/done.svg";

export default function AddCameras(props) {
  const { showModal, setShowModal } = props;

  const { t } = useTranslation();

  return (
    <Model
      height="sm:h-[500px] md:h-[50rem]"
      width="sm:w-[90%] md:w-[50rem]"
      show={showModal}
      onClose={(e) => {
        setShowModal(false);
      }}
    >
      <div className="flex flex-col justify-between h-full p-5">
        <div>
          <div className="font-bold text-center text-[48px]">
            {t("THANK YOU")}
          </div>
          <div className="text-[23.5px] text-[#717171] text-center ">
            {t("We have received your message, and will get back to you soon!")}
          </div>
        </div>
        <Image src={Done} alt="img" />
        <div
          onClick={() => setShowModal(false)}
          className="bg-main h-[50px] text-white text-[16px] font-bold flex items-center justify-center rounded-md cursor-pointer shadow hover:shadow-md bg-opacity-90 hover:bg-opacity-100"
        >
          {t("Done")}
        </div>
      </div>
    </Model>
  );
}
